import { lsLoad } from "../../tools/Storage";
import StorageEnum from "../../enums/Storage.enum";
import { useFileSelect } from "../../apis/file/useFileSelect.ts";
import { FileTargets } from "../../generated/fresh-guard-api";
import { useEffect } from "react";
import { extractMessageFromApi } from "../../tools/helpers/MessageHelper.ts";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { toastOptions } from "../../tools/helpers/ToastHelper.ts";

export const useBackgroundController = () => {
  const { t } = useTranslation();
  const market = lsLoad(StorageEnum.Market);
  const marketY = market?.configuration?.area?.height ?? 0;
  const marketX = market?.configuration?.area?.width ?? 0;

  const { data, error } = useFileSelect(
    market?.configuration?.filenameMarketDrawing,
    FileTargets.MarketDrawing,
  );

  useEffect(() => {
    if (!error) return;

    const extract = async () => {
      const details = (error as { details?: unknown }).details;
      if (details instanceof Blob) {
        const text = await details.text();
        toast.error(
          extractMessageFromApi(JSON.parse(text), t).message,
          toastOptions,
        );
      }
    };

    void extract();
  }, [error, t]);

  return {
    market,
    marketX,
    marketY,
    data,
  };
};
